import React, { useState } from 'react';
import { toast } from 'sonner';
import { LinkedinIcon, MailIcon, FileTextIcon, UsersIcon } from 'lucide-react';
import { useI18n } from '../lib/i18n';
export function Contact() {
  const {
    t
  } = useI18n();
  const [form, setForm] = useState({
    name: '',
    email: '',
    org: '',
    reason: 'colab',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setTimeout(() => {
      toast.success(t('contact.success'));
      setForm({
        name: '',
        email: '',
        org: '',
        reason: 'colab',
        message: ''
      });
      setSubmitting(false);
    }, 600);
  };
  const inputClass = 'w-full px-4 py-3 bg-white border border-black/[0.08] rounded-lg text-[#0A0A0F] text-sm placeholder-[#8A8A95] focus:outline-none focus:border-violet-electric/50 transition';
  const links = [{
    icon: LinkedinIcon,
    label: 'LinkedIn',
    href: '#'
  }, {
    icon: MailIcon,
    label: 'contact@clvn-lrr.com',
    href: 'mailto:contact@clvn-lrr.com'
  }, {
    icon: FileTextIcon,
    label: 'Papers',
    href: '#papers'
  }, {
    icon: UsersIcon,
    label: 'Collaborations',
    href: '#'
  }];
  return <section className="w-full bg-[#FAFAFA] py-32 px-6 md:px-12 border-t border-black/[0.06]" data-id="element-95">
      <div className="max-w-6xl mx-auto" data-id="element-96">
        <h2 className="font-display text-4xl md:text-5xl text-[#0A0A0F] mb-16 tracking-tight" data-id="element-97">
          {t('contact.title')}
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12" data-id="element-98">
          <form onSubmit={handleSubmit} className="lg:col-span-3 space-y-5" data-id="element-99">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-100">
              <div data-id="element-101">
                <label className="block text-xs uppercase tracking-widest text-[#4A4A55] mb-2 font-medium" data-id="element-102">
                  {t('contact.name')}
                </label>
                <input type="text" required value={form.name} onChange={e => setForm({
                ...form,
                name: e.target.value
              })} className={inputClass} data-id="element-103" />
              </div>
              <div data-id="element-104">
                <label className="block text-xs uppercase tracking-widest text-[#4A4A55] mb-2 font-medium" data-id="element-105">
                  {t('contact.email')}
                </label>
                <input type="email" required value={form.email} onChange={e => setForm({
                ...form,
                email: e.target.value
              })} className={inputClass} data-id="element-106" />
              </div>
            </div>
            <div data-id="element-107">
              <label className="block text-xs uppercase tracking-widest text-[#4A4A55] mb-2 font-medium" data-id="element-108">
                {t('contact.org')}
              </label>
              <input type="text" value={form.org} onChange={e => setForm({
              ...form,
              org: e.target.value
            })} className={inputClass} data-id="element-109" />
            </div>
            <div data-id="element-110">
              <label className="block text-xs uppercase tracking-widest text-[#4A4A55] mb-2 font-medium" data-id="element-111">
                {t('contact.reason')}
              </label>
              <select value={form.reason} onChange={e => setForm({
              ...form,
              reason: e.target.value
            })} className={inputClass} data-id="element-112">
                <option value="colab" data-id="element-113">{t('contact.reasons.colab')}</option>
                <option value="press" data-id="element-114">{t('contact.reasons.press')}</option>
                <option value="research" data-id="element-115">
                  {t('contact.reasons.research')}
                </option>
                <option value="other" data-id="element-116">{t('contact.reasons.other')}</option>
              </select>
            </div>
            <div data-id="element-117">
              <label className="block text-xs uppercase tracking-widest text-[#4A4A55] mb-2 font-medium" data-id="element-118">
                {t('contact.message')}
              </label>
              <textarea rows={5} required value={form.message} onChange={e => setForm({
              ...form,
              message: e.target.value
            })} className={`${inputClass} resize-none`} data-id="element-119" />
            </div>
            <button type="submit" disabled={submitting} className="px-8 py-3 bg-[#0A0A0F] hover:bg-[#2A2A35] disabled:opacity-50 text-white text-sm font-medium rounded-lg transition" data-id="element-120">
              {submitting ? '...' : t('contact.send')}
            </button>
          </form>

          <aside className="lg:col-span-2 lg:pl-8 lg:border-l border-black/[0.08]" data-id="element-121">
            <h3 className="text-xs uppercase tracking-widest text-violet-deep mb-6 font-medium" data-id="element-122">
              {t('contact.links')}
            </h3>
            <ul className="space-y-4" data-id="element-123">
              {links.map(link => {
              const Icon = link.icon;
              return <li key={link.label} data-id="element-124">
                    <a href={link.href} className="flex items-center gap-3 text-[#2A2A35] hover:text-[#0A0A0F] transition group" data-id="element-125">
                      <span className="w-9 h-9 flex items-center justify-center rounded-lg border border-black/[0.08] bg-white group-hover:border-violet-electric/40 transition" data-id="element-126">
                        <Icon className="w-4 h-4" aria-hidden="true" data-id="element-127" />
                      </span>
                      <span className="text-sm" data-id="element-128">{link.label}</span>
                    </a>
                  </li>;
            })}
            </ul>
          </aside>
        </div>
      </div>
    </section>;
}